export default __webpack_public_path__ + "static/media/Group 1884@3x.b1aa43f1.png";